import styled, { css, keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`

export const OptionStripeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const WarningMessage = styled.p`
  color: #D81212;
  font-size: 16px;
  padding: 16px;
  font-weight: 500;
  opacity: 0.9;
  background: linear-gradient(135deg, rgba(216, 18, 18, 0.08), rgba(216, 18, 18, 0.04));
  border-radius: 12px;
  border-left: 4px solid #D81212;
  margin: 0;
  ${props => props.theme?.rtl && css`
    border-left: none;
    border-right: 4px solid #D81212;
  `}
`

export const CardItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 12px;
  border: 2px solid ${({ isSelected }) => isSelected ? '#4CAF50' : '#E9ECEF'};
  background: ${({ isSelected }) => isSelected
    ? 'linear-gradient(135deg, rgba(76, 175, 80, 0.08), rgba(76, 175, 80, 0.02))'
    : '#FFFFFF'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 8px;
  box-shadow: ${({ isSelected }) => isSelected
    ? '0 4px 12px rgba(76, 175, 80, 0.15)'
    : '0 2px 8px rgba(0, 0, 0, 0.04)'};
  box-sizing: border-box;
  overflow: visible;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 576px) {
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
  }

  ${({ isCursor }) => isCursor && css`
    cursor: pointer;

    &:hover {
      border-color: ${({ isSelected }) => isSelected ? '#4CAF50' : '#4CAF50'};
      background: ${({ isSelected }) => isSelected
      ? 'linear-gradient(135deg, rgba(76, 175, 80, 0.12), rgba(76, 175, 80, 0.04))'
      : 'linear-gradient(135deg, rgba(76, 175, 80, 0.04), rgba(76, 175, 80, 0.02))'};
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    }
  `}
`

export const CardItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;

  .radio-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid ${({ isSelected }) => isSelected ? '#4CAF50' : '#CED4DA'};
    background: ${({ isSelected }) => isSelected ? '#4CAF50' : 'transparent'};
    transition: all 0.2s ease;
    flex-shrink: 0;

    svg {
      color: #FFFFFF;
      font-size: 14px;
      opacity: ${({ isSelected }) => isSelected ? 1 : 0};
      transition: opacity 0.2s ease;
    }
  }

  .card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 28px;
    background: linear-gradient(135deg, #F8F9FA, #E9ECEF);
    border-radius: 6px;
    padding: 4px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: auto;
      max-height: 20px;
      object-fit: contain;
    }
  }

  .card-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;

    .card-number {
      font-size: 14px;
      font-weight: 600;
      color: ${props => props.theme?.colors?.headingColor || '#1A1A2E'};
      letter-spacing: 0.3px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .card-brand {
      font-size: 11px;
      color: ${props => props.theme?.colors?.grayColor || '#6C757D'};
      text-transform: capitalize;
    }
  }
`

export const CardItemActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 576px) {
    width: 100%;
    justify-content: space-between;
  }
`

export const CvvInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  label {
    font-size: 13px;
    color: ${props => props.theme?.colors?.grayColor || '#6C757D'};
    font-weight: 500;
  }

  input {
    width: 64px;
    height: 36px;
    border: 2px solid #E9ECEF;
    border-radius: 8px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 2px;
    color: #1A1A2E;
    background: #FFFFFF;
    transition: all 0.2s ease;
    outline: none;

    &:focus {
      border-color: #4CAF50;
      box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.15);
    }

    &::placeholder {
      color: #ADB5BD;
      letter-spacing: normal;
    }
  }
`

export const BlockLoading = styled.div`
  width: 100%;
  margin-bottom: 12px;
  padding: 16px 20px;
  border-radius: 12px;
  background: linear-gradient(to right, #F6F7F8 8%, #EDEEF1 18%, #F6F7F8 33%);
  background-size: 936px 104px;
  animation: ${shimmer} 1.5s infinite linear;
  height: 72px;
`

export const AddNewCard = styled.div`
  margin-top: 8px;
  padding: 16px 20px;
  border: 2px dashed #E9ECEF;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: ${props => props.theme?.colors?.primary || '#4CAF50'};
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.04), transparent);
  }

  span {
    font-size: 15px;
    font-weight: 600;
    color: ${props => props.theme?.colors?.primary || '#4CAF50'};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    user-select: none;

    svg {
      font-size: 18px;
    }
  }
`

export const CardItemActionsWrapper = styled.div`
  position: relative;

  .delete-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: transparent;
    border: none;
    color: #6C757D;

    svg {
      font-size: 18px;
    }

    &:hover {
      background: rgba(230, 55, 87, 0.1);
      color: #E63757;
    }
  }
`

export const ActionsContent = styled.div`
  position: absolute;
  z-index: 10;
  top: 100%;
  margin-top: 4px;
  background: #FFFFFF;
  border: 1px solid #E9ECEF;
  box-sizing: border-box;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  overflow: hidden;
  min-width: 120px;
  ${props => props.theme?.rtl ? css`left: 0;` : css`right: 0;`}

  div {
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    color: ${props => props.theme?.colors?.headingColor || '#1A1A2E'};
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
      background: #f8f9fa;
    }

    &.delete {
      color: #E63757;
    }

    svg {
      font-size: 16px;
    }
  }
`

export const NoCardsMessage = styled.div`
  padding: 24px;
  text-align: center;
  background: linear-gradient(135deg, #F8F9FA, #FFFFFF);
  border-radius: 12px;
  border: 1px solid #E9ECEF;

  .icon {
    width: 48px;
    height: 48px;
    margin: 0 auto 12px;
    background: linear-gradient(135deg, #E9ECEF, #DEE2E6);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      font-size: 24px;
      color: #6C757D;
    }
  }

  span {
    font-size: 15px;
    color: #6C757D;
    font-weight: 500;
  }
`

export const PaymentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E9ECEF;

  .logo-container {
    display: flex;
    align-items: center;
    gap: 12px;

    img {
      height: 28px;
      width: auto;
      object-fit: contain;
    }
  }

  .secure-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
    padding: 6px 12px;
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.05));
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    color: #4CAF50;

    svg {
      font-size: 14px;
    }

    ${props => props.theme?.rtl && css`
      margin-left: 0;
      margin-right: auto;
    `}
  }
`
